// 全省今日征订概况（按时间维度）模块
const state = {
  day: null,      // 今日数据
  week: null,     // 本周数据
  semester: null, // 本学期数据
  year: null      // 本年数据
}

const mutations = {
  SET_DATA(state, data) {
    if (data) {
      state.day = data.day || null
      state.week = data.week || null
      state.semester = data.semester || null
      state.year = data.year || null
    }
  },
  RESET_DATA(state) {
    state.day = null
    state.week = null
    state.semester = null
    state.year = null
  }
}

const getters = {
  // 获取指定时间维度的数据
  getByPeriod: state => period => {
    return state[period] || null
  },
  // 所有时间维度数据
  allPeriods: state => ({
    day: state.day,
    week: state.week,
    semester: state.semester,
    year: state.year
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
